<template>
  <div id="mi-box">
    <!-- Text and icon for larger width pages -->
    <span class="text-sm" id="moreInfo-long">
      <button id="moreInfo">
        <a target="_blank" :href="this.catalogUrl">
          More Info
        </a>
      </button>
    </span>
    <!-- Icon button for smaller width pages -->
    <span id="moreInfo-short">
      <button id="moreInfo">
        <a target="_blank" :href="this.catalogUrl">
          <i class="fas fa-info"> </i>
        </a>
      </button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    mod_code: String,
    start_year: Number
  },
  computed: {
    // Extract properties for syllabus catalog
    subjCodeIn: function() {
      return this.mod_code.match(/^[A-Z]+/i)[0];
    },
    crseNumbIn: function() {
      return this.mod_code.match(/\d+$/)[0];
    },
    catalogUrl: function() {
      const year = `${this.start_year}${(this.start_year + 1) % 100}`
      return `https://royalholloway.akarisoftware.com/index.cfm/page/module/moduleCode/${this.subjCodeIn}${this.crseNumbIn}`;
    },
  },
};
</script>

<style scoped>

#mi-box {
  display: inline;
  padding: 0.5em;
  height: auto;
}

#moreInfo-short,
#moreInfo-long {
  height: 100%;
  margin-right: 0.25em;
  position: relative;
  float: right;
}

#moreInfo {
  float: right;
  position: relative;
  margin: 0;

  padding-left: 0.25em;
  padding-right: 0.25em;

  padding-top: 0.15em;
  padding-bottom: 0.15em;

  border-radius: 0.25em;
  background: lightgray;
  transition: 0.15s;
}

#moreInfo:hover {
  background: rgb(220, 220, 220);
}

</style>
